<template>
  <div class="Stock">
    <div class="page-title">{{ $t("lang.material_inventory") }}</div>
    <div>
      <ATable
        ref="table"
        v-loading="loading"
        max-height="750px"
        buttons-width="400px"
        :placeholder="placeholder"
        :data="items"
        hide-pagination
        hide-button-insert
        highlight-current-row
        border
        @row-click="handleClickRow"
        @selection-change="handleSelectionChange"
      >
        <div slot="search">
          <div class="flex">
            <div class="flex title-wrapper">
              <span class="title">품목:</span>
              <el-input
                v-if="piece_productname"
                v-model="searchWord"
                class="ml-default"
                size="mini"
                placeholder="품목번호, 품목명"
              ></el-input>
              <AProductSelector
                v-else
                class="ml-default"
                :value="data ? data.product_name : ''"
                @select="handleSelectProduct"
                @clear="handleClear"
              />
            </div>
            <div class="inline ml-default">
              <el-button
                type="primary"
                size="mini"
                round
                v-shortkey="['f5']"
                @shortkey.native="handleClickSearch"
                @click="handleClickSearch"
                >{{ $t("button.search") }}(F5)</el-button
              >
            </div>
            <div class="inline ml-default">
              <el-checkbox v-model="piece_productname">일부 품목명</el-checkbox>
            </div>
          </div>
        </div>
        <el-table-column
          type="selection"
          align="center"
          :width="$width.selection"
        />
        <el-table-column
          type="index"
          label="No"
          align="center"
          :index="handleIndex"
        />
        <el-table-column
          prop="product_code"
          width="60"
          :label="$t('lang.code')"
        />
        <el-table-column
          prop="type_name"
          :label="$t('lang.product_classification')"
        />
        <el-table-column
          prop="product_name"
          :label="$t('lang.product')"
          show-overflow-tooltip
        />
        <el-table-column prop="size" :label="$t('lang.size')" />
        <el-table-column prop="unit_name" width="60" label="단위" />
        <el-table-column
          prop="current_amount"
          width="100"
          class-name="cell-number"
          :label="$t('lang.current_quantity')"
          :formatter="resolveAmount"
        />
        <el-table-column
          prop="safety_amount"
          class-name="cell-number"
          width="100"
          :label="$t('lang.safety_stock')"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="purchase_costs"
          class-name="cell-number"
          width="100"
          label="매입원가"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="status_flag"
          :label="$t('lang.state')"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span v-bind:class="{ emergency: scope.row.is_emergency }">
              {{ resolveStatus(scope.row.is_emergency) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <div slot="buttons">
          <el-button
            type="primary"
            :disabled="!has_grant_write"
            @click="handleClickSafetyStock"
            >{{ $t("button.regist_safety_stock") }}</el-button
          >
          <el-button
            type="primary"
            :disabled="!has_grant_write"
            @click="handleClickStockReg"
            >재고 등록</el-button
          >
          <el-upload
            class="inline"
            style="margin-left:10px"
            action="#"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="handleOnChange"
          >
            <el-button :disabled="!has_grant_write">재고 엑셀 등록</el-button>
          </el-upload>
          <el-button
            type="danger"
            style="margin-left:10px;"
            v-if="selection.length > 0"
            :disabled="!has_grant_write"
            @click="handleClickStockRemove"
            >재고 삭제</el-button
          >
        </div>
      </ATable>
    </div>
    <!-- <div v-if="showHistory" class="row-splitter">
      <StockHistory
        :data="selectedData"
        :has_grant_write="has_grant_write"
        @change="loadData"
      ></StockHistory>
    </div>-->
    <el-dialog
      title="안전재고 수량 등록"
      top="0"
      custom-class="form-dialog stock-dialog"
      destroyOnClose
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <SafetyStockForm ref="form" @completed="handleCompletedSafetyStock" />
    </el-dialog>
    <el-dialog
      title="재고 등록"
      top="0"
      custom-class="form-dialog stock2-dialog"
      destroyOnClose
      :visible.sync="dialog2Visible"
      :close-on-click-modal="false"
    >
      <StockForm
        ref="form"
        :data="selectedData"
        @completed="handleCompletedForm"
      />
    </el-dialog>
    <el-dialog
      title="엑셀 등록 정보"
      top="0"
      width="1200px"
      custom-class="form-dialog stock2-dialog"
      destroyOnClose
      :visible.sync="dialogExcelVisible"
      :close-on-click-modal="false"
    >
      <div>
        <ATable
          v-loading="loading"
          ref="excel_table"
          v-if="excel_items.length > 0"
          :data="excel_items"
          max-height="200px"
          hideTopPanel
          hideButtonExcel
          hide-pagination
          hideButtonInsert
          border
          :rowClassName="handleRowClassName"
          @selection-change="handleExcelSelectionChange"
        >
          <el-table-column
            type="selection"
            width="30"
            :selectable="selectable"
          />
          <el-table-column
            type="index"
            label="No"
            align="center"
            prop="index"
            :width="$width.index"
            :index="handleExcelIndex"
          />
          <el-table-column prop="product_name" label="품목명" width="250" />
          <el-table-column label="규격" prop="size" width="150">
            <template slot-scope="scope">
              <div v-if="selectable(scope.row)">
                <el-input size="mini" v-model="scope.row.size" />
              </div>
              <div v-else>{{ scope.row.size }}</div>
            </template>
          </el-table-column>
          <el-table-column label="수량" prop="amount" width="80">
            <template slot-scope="scope">
              <div v-if="selectable(scope.row)">
                <el-input size="mini" v-model="scope.row.amount" />
              </div>
              <div v-else>{{ scope.row.amount }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="확인날짜"
            prop="deal_date"
            :width="$width.date"
            :formatter="util.dateFormat"
          />
          <el-table-column label="비고" prop="desc">
            <template slot-scope="scope">
              <div v-if="selectable(scope.row)">
                <el-input size="mini" v-model="scope.row.desc" />
              </div>
              <div v-else>{{ scope.row.amount }}</div>
            </template>
          </el-table-column>
        </ATable>
        <div slot="buttons">
          <el-button
            v-if="excel_items.length > 0"
            type="primary"
            :disabled="excel_selection.length < 1 || !has_grant_write"
            :loading="button_loading"
            @click="handleClickExcelRegister"
            >등록</el-button
          >
          <el-button
            v-if="excel_items.length > 0"
            style="margin-left:10px"
            :loading="button_loading"
            @click="handleClickExcelCancel"
            >취소</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { authority_level } from "@/common/mixins/authority_level";
// import StockHistory from "./StockHistory";
import SafetyStockForm from "./SafetyStockForm";
import StockForm from "./StockForm";
import XLSX from "xlsx";
import AProductSelector from "../../shared/AProductSelector.vue";

export default {
  name: "Stock",
  mixins: [authority_level],
  components: {
    // StockHistory,
    SafetyStockForm,
    StockForm,
    AProductSelector,
  },
  data() {
    return {
      search_field: ["code", "product_name"],
      placeholder: "품목번호, 품목명",
      loading: false,
      items: [],
      showHistory: false,
      selectedData: undefined,
      selection: [],
      dialogVisible: false,
      dialog2Visible: false,
      dialogExcelVisible: false,
      excel_items: [],
      excel_selection: [],
      working: false,
      button_loading: false,
      piece_productname: false,
      data: undefined,
      searchWord: "",
    };
  },
  computed: {
    ...mapGetters(["table_product", "table_product_type", "table_unit"]),
    has_grant_write() {
      return this.isWriteLevel("stock_manage");
    },
  },
  watch: {
    table_product: function() {
      this.loadData();
    },
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {
    loadData() {
      this.loading = true;
      let param = {};
      if (this.piece_productname) {
        param.product_id = this.searchWord === "" ? null : this.searchWord;
      } else {
        param.product_id = this.data ? this.data.product_id : null;
      }
      param.piece_productname = this.piece_productname ? "Y" : "N";
      this.api.listProductStock(param).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, "수주", res.message);
          return;
        }
        let items = res.data;
        items.forEach((item) => {
          this.addProductAttribute(item);
        });
        this.selection = [];
        this.items = items;
      });
    },
    /** idb에서 조회하여 표시 데이터 속성을 추가 */
    addProductAttribute(data) {
      let p = this.table_product.find((p) => p.id === data.product_id);
      let type, u;
      if (p) {
        data.product_code = p.code;
        data.product_name = p.name;
        type = this.table_product_type.find((t) => t.id === p.type_id);
        u = this.table_unit.find((u) => u.id === p.unit_id);
      }
      data.type_name = type ? type.name : "";
      data.purchase_costs = p.purchase_cost * data.current_amount;
      if (u) {
        data.unit_name = u.name;
        if (u.multiply) {
          data.current_amount = data.current_amount / u.multiply;
          data.safety_amount = data.safety_amount / u.multiply;
        }
      }
      data.is_emergency =
        data.current_amount + data.reserved_amount <= data.safety_amount;
    },
    resolveAmount(data) {
      return this.util.addComma(data.current_amount + data.reserved_amount);
    },
    resolveStatus(is_emergency) {
      if (is_emergency) {
        return "긴급";
      } else {
        return "여유";
      }
    },
    handleClickSearch() {
      if (this.working) {
        this.showExcelWorkingMsg();
        return;
      }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickRow(data) {
      this.showHistory = true;
      this.selectedData = data;
    },
    handleSelectionChange(selection) {
      // 수주 선택 처리
      this.selection = selection;
    },
    handleClickSafetyStock() {
      if (this.working) {
        this.showExcelWorkingMsg();
        return;
      }
      if (this.selection.length < 1) {
        this.util.notify(
          this,
          "w",
          this.$t("lang.stock"),
          this.$t("message.no_selection")
        );
        return;
      }
      this.dialogVisible = true;
    },
    handleClickStockReg() {
      if (this.working) {
        this.showExcelWorkingMsg();
        return;
      }
      this.dialog2Visible = true;
    },
    handleCompletedSafetyStock(val) {
      this.dialogVisible = false;
      if (!val) {
        return;
      }
      let id = [];
      this.selection.forEach((s) => {
        id.push(s.id);
      });
      let param = { id: id, safety_stock: val };
      this.api.updateSafetyStock(param).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, this.$t("lang.stock"), res.message);
          return;
        }
        this.loadData();
      });
    },
    handleCompletedForm(data) {
      this.dialog2Visible = false;
      if (!data) {
        return;
      }
      this.loadData();
      let clone = Object.assign({}, this.selectedData);
      this.selectedData = null;
      this.selectedData = clone;
    },
    handleOnChange(event) {
      if (this.working) {
        this.showExcelWorkingMsg();
        return;
      }
      const file = event.raw;
      const reader = new FileReader();
      reader.onload = this.loadExcel;
      reader.readAsArrayBuffer(file);
    },
    loadExcel(e) {
      let tmpResult = {};
      let data = e.target.result;
      data = new Uint8Array(data);
      // get excel file
      let excelFile;
      try {
        excelFile = XLSX.read(data, {
          type: "array",
          cellDates: true,
          cellNF: false,
          cellText: false,
        });
      } catch (ex) {
        this.util.notify_error(this, this.title, "엑셀 파일이 아닙니다.");
        return;
      }
      // get prased object
      excelFile.SheetNames.forEach(function(sheetName) {
        const roa = XLSX.utils.sheet_to_json(
          excelFile.Sheets[sheetName],
          {
            header: [
              "no",
              "product_name",
              "size",
              "amount",
              "deal_date",
              "desc",
            ],
          },
          { raw: true, dateNF: "YYYY-MM-DD" }
        );
        if (roa.length) tmpResult[sheetName] = roa;
      });
      this.parseExcel(tmpResult[excelFile.SheetNames[0]]);
      this.dialogExcelVisible = true;
    },
    parseExcel(result) {
      // 헤더 정보 제거
      result.splice(0, 2);
      result.forEach((item) => {
        let data = {
          product_name: item["product_name"],
          size: item["size"],
          amount: item["amount"],
          deal_date: item["deal_date"],
          desc: item["desc"],
        };
        let product = this.table_product.find(
          (findItem) => findItem.name === data.product_name
        );
        if (!product) {
          data.product_id = 0;
          data.is_exist_product = true;
        } else {
          data.product_id = product.id;
          data.is_exist_product = false;
        }
        this.excel_items.push(data);
      });
    },
    handleExcelSelectionChange(selection) {
      this.excel_selection = selection;
    },
    selectable(row) {
      let product = this.table_product.find(
        (findItem) => findItem.name === row.product_name
      );
      return !!product;
    },
    handleExcelIndex(index) {
      return this.$refs.excel_table.indexResolver(index);
    },
    handleClickExcelRegister() {
      if (this.working) {
        this.showExcelWorkingMsg();
        return;
      }
      this.working = true;

      let data_list = [];
      this.excel_selection.forEach((item) => {
        if (item.product_id > 0) {
          item.type_flag = "I";
          item.unit_id = 1;
          item.outbound = 0;
          item.deal_date = this.util.getDateString(item.deal_date);
          item.size = item.size ? item.size : "";
          item.desc = item.desc ? item.desc : "";
          data_list.push(item);
        }
      });
      this.button_loading = true;
      this.api.createStcokByExcel(data_list).then((res) => {
        this.button_loading = false;
        this.excel_items = [];
        this.handleResponse(res, "재고 등록에 성공했습니다.");
        this.working = false;
        this.dialogExcelVisible = false;
      });
    },
    handleClickExcelCancel() {
      this.excel_items = [];
      this.dialogExcelVisible = false;
    },
    handleRowClassName({ row }) {
      if (row.is_exist_product) {
        return "warning-row";
      }
      return "";
    },
    handleResponse(res, successMessage) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.excel_items = [];
      this.excel_selection = [];
      this.util.notify_success(this, this.title, successMessage);
      this.loadData();
    },
    showExcelWorkingMsg() {
      this.util.notify(
        this,
        "w",
        this.$t("lang.stock"),
        "엑셀 재고 정보를 등록 중입니다."
      );
    },
    doDelete() {
      this.api.deleteProductStock(this.selection).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, "자재 재고 삭제 실패", res.message);
          return;
        }
        this.showHistory = false;
        this.loadData();
      });
    },
    handleClickStockRemove() {
      this.util.confirm_delete(this, this.$t("lang.stock"), this.doDelete);
    },
    handleSelectProduct(product) {
      if (!product || typeof product === "string") {
        this.data = undefined;
      } else {
        this.data = {
          product_id: product.id,
          product_name: product.name,
          size: product.size,
        };
      }
    },
  },
};
</script>

<style>
.stock-dialog {
  width: 220px;
}
.stock2-dialog {
  width: 440px;
}
</style>
<style lang="scss">
.Stock {
  .emergency {
    color: red;
    font-weight: bold;
  }
  .excel-title {
    font-size: 13px;
    font-weight: bold;
  }
  .excel-info {
    border: 1px solid;
    border-radius: 4px;
    padding: 10px;
    margin-top: 20px;
  }
  .el-table .warning-row {
    background: lightgray;
  }
}
.title-wrapper {
  width: 300px;
}
.title {
  font-weight: bold;
  min-width: 30px;
}
.text {
  min-width: 60px;
  display: inline-block;
}
</style>
